import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button, CssBaseline, IconButton } from "@mui/material";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { DatePicker, DateRangePicker } from "rsuite";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import PreviewIcon from "@mui/icons-material/Preview";
import DownloadIcon from "@mui/icons-material/Download";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import { RemoveIcon } from "../../assets/images";
import {
  createDownloadRequest,
  getReportList,
} from "../../services/configurationServices";
import { getReportIndexColumns } from "./ReportIndexColumnConfig";
import { ConvertDateToUTC } from "../../utils/dateUtils";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import {
  getDownloadRequestList,
  getExecuteReport,
} from "../../services/reportService";
import AlertTemplateMessage from "../Configuration/AlertTemplate/AlertTemplateMessage";
import { CircularProgress } from "@mui/material";

const ReportIndex = ({
  currentReport,
  setCurrentReport,
  reportFromDate,
  setReportFromDate,
  reportToDate,
  setReportToDate,
}) => {
  const [show, setShow] = useState();
  const [showViewModal, setShowViewModal] = useState();
  const [showRequestModal, setShowRequestModal] = useState();
  const [reportData, setReportData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true); // Loader state

  const now = new Date();

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(now.getDate() - 30);

  //const [reportFromDate, setReportFromDate] = useState(null);
  //const [reportToDate, setReportToDate] = useState(null);

  const [downloadReportFromDate, setDownloadReportFromDate] = useState(null);
  const [downloadReportToDate, setDownloadReportToDate] = useState(null);

  //const [currentReport, setCurrentReport] = useState(null);
  const [dateError, setDateError] = useState("");
  const [downloadDateError, setDownloadDateError] = useState("");

  const [downloadRequestData, setDownloadRequestData] = useState([]);

  const user = JSON.parse(localStorage.getItem("user"));

  const initializeViewReport = () => {
    const now = new Date();

    const todayMidnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
      0
    );
    const oneWeekAgoMidnight = new Date(todayMidnight);
    oneWeekAgoMidnight.setDate(todayMidnight.getDate() - 7);

    setReportFromDate(oneWeekAgoMidnight);
    setReportToDate(now);
  };

  const initializeDownloadReport = () => {
    const now = new Date();
    const todayMidnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
      0
    );
    const thirtyDaysAgo = new Date(todayMidnight);
    thirtyDaysAgo.setDate(now.getDate() - 30);

    setDownloadReportFromDate(thirtyDaysAgo);
    setDownloadReportToDate(now);
  };

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const response = await getReportList();
        setReportData(response?.Data);

        // Remove spaces from key names and store in tableData
        if (response?.Data && Array.isArray(response.Data)) {
          const transformed = response.Data.map((row) => {
            const newRow = {};
            Object.keys(row).forEach((key) => {
              const newKey = key.replace(/\s+/g, "");
              newRow[newKey] = row[key];
            });
            return newRow;
          });
          setTableData(transformed);
        } else {
          setTableData([]);
        }
      } catch (error) {
        console.error("Error fetching report data:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchReportData();

    // Cleanup function to reset report data when component unmounts
    return () => {
      setReportData([]);
      setTableData([]);
    };
  }, []);

  function isWithinOneMonth(from, to) {
    if (!from || !to) return true;
    const diff = to.getTime() - from.getTime();
    const oneMonthMs = 30 * 24 * 60 * 60 * 1000; // 31 days in ms
    return diff <= oneMonthMs && diff >= 0;
  }

  const handleFromDateChange = (date) => {
    setReportFromDate(date);
    if (reportToDate && date > reportToDate) {
      setDateError("From date cannot be after To date.");
      return;
    }
    if (reportToDate && !isWithinOneMonth(date, reportToDate)) {
      setDateError("Date range cannot exceed 1 month.");
      return;
    }
    setDateError("");
    setReportFromDate(date);
  };

  const handleToDateChange = (date) => {
    setReportToDate(date);
    if (reportFromDate && date < reportFromDate) {
      setDateError("To date cannot be before From date.");
      return;
    }
    if (reportFromDate && !isWithinOneMonth(reportFromDate, date)) {
      setDateError("Date range cannot exceed 1 month.");
      return;
    }
    setDateError("");
    setReportToDate(date);
  };

  const handleDownloadFromDateChange = (date) => {
    setDownloadReportFromDate(date);
    if (downloadReportToDate && date > downloadReportToDate) {
      setDownloadDateError(`"From Date" cannot be after "To Date."`);
      return;
    }
    // if (downloadReportToDate && !isWithinOneMonth(date, downloadReportToDate)) {
    //   setDownloadDateError("Date range cannot exceed 1 month.");
    //   return;
    // }
    setDownloadDateError("");
    
  };

  const handleDownloadToDateChange = (date) => {
    setDownloadReportToDate(date);
    if (downloadReportFromDate && date < downloadReportFromDate) {
      setDownloadDateError(`"To Date" cannot be before "From Date".`);
      return;
    }
    // if (downloadReportFromDate && !isWithinOneMonth(downloadReportFromDate, date)) {
    //     setDownloadDateError("Date range cannot exceed 1 month.");
    //     return;
    // }
    setDownloadDateError("");
  };

  const handleView = (data) => {
    const { DateParameterFlag } = data || {};
    if(DateParameterFlag === 0) {
      initializeViewReport();
      openViewReport(data);
      return;
    }
    initializeViewReport();
    setShowViewModal(true);
    setCurrentReport(data);
    setDateError("");
  };

  const handleDownload = (data) => {
    const { DateParameterFlag } = data || {};
    initializeDownloadReport();
    if(DateParameterFlag === 0) {
      handleDownloadRequest(data);
      return;
    }
    setCurrentReport(data);
    setShow(true);
    setDownloadDateError("");
  };

  const handleDownloadRequest = async (data) => {
    const { DateParameterFlag } = data || {};
    const payload = {
      UserID: user?.Id,
      ReportID: data["ReportID"],
      RequestedByEmailID: user?.Email,
    };

    if(DateParameterFlag !== 0) {
      payload.FromDateTime = ConvertDateToUTC(downloadReportFromDate);
      payload.ToDateTime = ConvertDateToUTC(downloadReportToDate);
    }

    try {
      const response = await createDownloadRequest(payload);
      if (response?.Status === "success") {
        setShow(false);
        //setShowRequestModal(true);
        SuccessToast("Download request submitted successfully");
      } else {
        ErrorToast("Error in adding download request");
      }
    } catch (error) {
      console.error("Error in download request:", error);
    }
  };

  const handleViewRequest = async (data) => {
    setShowRequestModal(true);
    try {
      const now = new Date();
      const fromDate = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 24 hours before now

      const payload = {
        UserID: user?.Id,
        ReportID: data["ReportID"],
        FromDateTime: ConvertDateToUTC(fromDate),
        ToDateTime: ConvertDateToUTC(now),
      };
      const response = await getDownloadRequestList(payload);
      setDownloadRequestData(response?.Data || []);
    } catch (error) {
      console.error("Error fetching download request list:", error);
      setDownloadRequestData([]);
    }
  };

  const columns = getReportIndexColumns(
    handleView,
    handleDownload,
    handleViewRequest
  );

  const showReportPath = downloadRequestData.some(row => row.DeploymentType === 1);
  const history = useHistory();

  const handleViewChange = (data) => {
    openViewReport(data);
  };

  const openViewReport = (data) => {
    history.push({
      pathname: "/report-view",
      state:{ currentReport: data, reportFromDate, reportToDate },
    });
  };

  return (
    <>
      <div className="MainContentMargin">
        <div className="col-lg-12 HMHeader mt-3 mb-3">
          <div className="NameHeading1" style={{ width: "100%" }}>
            <p className="config-tool-head" style={{ float: "left" }}>
              Reports
            </p>
          </div>
        </div>
        {loading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "40vh",
              width: "100%",
            }}
          >
            <CircularProgress />
            <div
              style={{
                marginTop: "1rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Loading report data, please wait...
            </div>
          </div>
        ) : tableData && tableData.length > 0 ? (
          <div className="col-lg-12 TabulerReportMainDiv MatReactTableDiv">
            <div className="card-body p-0">
              <MaterialReactTable
                columns={columns}
                data={tableData}
                enableColumnFilters={false}
                enableGlobalFilter={true}
                //globalFilterFn={exactGlobalFilterFn}
                globalFilterFn="contains"
                enableStickyHeader
                enableColumnResizing
                initialState={{ showColumnFilters: true }}
                muiTableContainerProps={{
                  className: "MaterialTableJs",
                  sx: {
                    maxHeight: "100%",
                    overflow: "auto",
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  },
                }}
                muiTableHeadProps={{
                  className: "myHeader",
                    sx: {
                        display: tableData.length === 0 ? 'none' : 'table-header-group',
                    },
                }}
              />

              <Modal
                size="lg"
                show={showViewModal}
                onHide={() => setShowViewModal(false)}
                dialogClassName="modal-90w"
                backdrop="static"
                className="AddCustomerModal"
              >
                <Modal.Header>
                  <Modal.Title id="example-custom-modal-styling-title">
                    View report
                  </Modal.Title>
                  <img
                    src={RemoveIcon}
                    alt="Remove"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowViewModal(false);
                    }}
                  />
                </Modal.Header>
                <Modal.Body>
                  <div className="d-flex mb-4 justify-content-center downloadModal">
                    {/* validation upto 1week selection */}
                    <div>
                      <label className="mr-2">From </label>
                      <DatePicker
                        format="dd-MM-yyyy HH:mm:ss"
                        editable={true}
                        value={reportFromDate}
                        onChange={handleFromDateChange}
                        disabledDate={(date) => date > new Date()}
                      />
                    </div>

                    <div className="ml-3">
                      <label className="mr-2">To</label>
                      <DatePicker
                        format="dd-MM-yyyy HH:mm:ss"
                        editable={true}
                        value={reportToDate}
                        onChange={handleToDateChange}
                        disabledDate={(date) => date > new Date()}
                      />
                    </div>
                  </div>
                  {dateError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "0.9em",
                        marginTop: 4,
                        textAlign: "center",
                      }}
                    >
                      <strong>{dateError}</strong>
                    </div>
                  )}

                  <div style={{ textAlign: "center" }}>
                    <button
                      className="DataAccessEdit mt-3"
                      style={{ width: "100px" }}
                      disabled={!!dateError}
                      onClick={() => {
                        handleViewChange(currentReport);
                      }}
                    >
                      <span className="ViewUpdate">View</span>
                    </button>
                    <button
                      className="DataAccessEdit mt-3"
                      style={{ width: "100px" }}
                      onClick={() => {
                        setShowViewModal(false);
                      }}
                    >
                      <span className="ViewUpdate">Cancel</span>
                    </button>
                  </div>
                </Modal.Body>
              </Modal>

              <Modal
                size="lg"
                show={show}
                onHide={() => setShow(false)}
                dialogClassName="modal-90w"
                backdrop="static"
                className="AddCustomerModal"
              >
                <Modal.Header>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Report download request
                  </Modal.Title>
                  <img
                    src={RemoveIcon}
                    alt="Remove"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShow(false);
                    }}
                  />
                </Modal.Header>
                <Modal.Body>
                  <div className="d-flex mb-4 justify-content-center downloadModal">
                    <div>
                      <label className="mr-2">From </label>
                      <DatePicker
                        format="dd-MM-yyyy HH:mm:ss"
                        editable={true}
                        value={downloadReportFromDate}
                        onChange={handleDownloadFromDateChange}
                        disabledDate={(date) => date > new Date()}
                      />
                    </div>

                    <div className="ml-3">
                      <label className="mr-2">To</label>
                      <DatePicker
                        format="dd-MM-yyyy HH:mm:ss"
                        editable={true}
                        value={downloadReportToDate}
                        onChange={handleDownloadToDateChange}
                        disabledDate={(date) => date > new Date()}
                      />
                    </div>
                  </div>
                  {downloadDateError && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "0.9em",
                        marginTop: 4,
                        textAlign: "center",
                      }}
                    >
                      <strong>{downloadDateError}</strong>
                    </div>
                  )}
                  <div style={{ textAlign: "center" }}>
                    <button
                      className="DataAccessEdit mt-3"
                      style={{ width: "100px" }}
                      disabled={!!downloadDateError}
                      onClick={() => handleDownloadRequest(currentReport)}
                    >
                      <span className="ViewUpdate">Submit</span>
                    </button>
                    <button
                      className="DataAccessEdit mt-3"
                      style={{ width: "100px" }}
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <span className="ViewUpdate">Cancel</span>
                    </button>
                  </div>
                </Modal.Body>
              </Modal>

              <Modal
                size="xl"
                show={showRequestModal}
                onHide={() => setShowRequestModal(false)}
                dialogClassName="modal-90w"
                backdrop="static"
                className="AddCustomerModal ViewRequestModal"
              >
                <Modal.Header>
                  <Modal.Title id="example-custom-modal-styling-title">
                    My request(For Today)
                  </Modal.Title>
                  <img
                    src={RemoveIcon}
                    alt="Remove"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowRequestModal(false);
                    }}
                  />
                </Modal.Header>
                <Modal.Body>
                 <div className="tableIndexRequest">
                      <table className="table table-bordered custom-table">
                    <thead>
                      <tr>
                        <th>Report Name</th>
                        <th>Request Time</th>
                        <th>Status</th>
                        <th>Request Username</th>
                        <th>Report Sent Time</th>
                        <th>Exception</th>
                        {showReportPath && <th>Report Path</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {downloadRequestData && downloadRequestData.length > 0 ? (
                        downloadRequestData.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row["Report Name"] || "-"}</td>
                            <td>
                              {row["Request DateTime"]
                                ? new Date(
                                    row["Request DateTime"] + "Z"
                                  ).toLocaleString()
                                : "-"}
                            </td>
                            <td>{row["Request Status"] || "-"}</td>
                            <td>{row["RequestedBy EmailID"] || "-"}</td>
                            <td>
                              {row["RequestedProcessed DateTime"]
                                ? new Date(
                                    row["RequestedProcessed DateTime"] + "Z"
                                  ).toLocaleString()
                                : "-"}
                            </td>
                            <td>{row["Fail Message"] || "-"}</td>
                            {showReportPath && (
                              row["ReportDownloadPath"] ? (<td>{row["ReportDownloadPath"]}</td>) :(<td>-</td>)
                            )}
                            {/* <td>{row["ReportDownloadPath"]?<a href={row["ReportDownloadPath"]}>{row["Report Name"]}.csv</a>:"-"}</td> */}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={7}
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            No requests found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        ) : (
          <div className="col-lg-12 HMHeader" style={{ width: "100%" }}>
            <AlertTemplateMessage message={`No records to display `} />
          </div>
        )}
      </div>
    </>
  );
};

export default ReportIndex;
